import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { AvailablePromotionRequest, AvailablePromotionResponse } from '@atlassian/commerce-ccp-gateway-client';
import { EligiblePromotionRequestDto } from '@atlassian/cssxp-ccp-types';
import { Benefit } from '@css-xp/graphtypes/src/generated-types-new';

const promotionClient = createAxiosClient({ baseURL: '/api/1/promotions' }, ServiceProxyMap.ANS);

type AvailablePromotionResponseWithExpand = AvailablePromotionResponse & {
  promotions?: { promotionId: string; benefits: Benefit[] }[];
};
// These proxies are specific to PPC
type RequestPayloadPartnerPromotions =
  | (AvailablePromotionRequest & {
      partnerStatus?: {
        discountTier: string;
        programLevelGlobal: string | null;
      };
    })
  | EligiblePromotionRequestDto;
export const getPartnerPromotions = async (
  requestPayload: RequestPayloadPartnerPromotions,
  isExpanded = false
): Promise<AvailablePromotionResponseWithExpand | undefined> => {
  const response = await promotionClient.post(`/get-partner-promotions?expand=${isExpanded}`, requestPayload);
  return response.data;
};
